var i=function(i){void 0===i&&(i=0);return{width:window.innerWidth-96,height:window.innerHeight-(96+i)}};export{i as getFullScreenViewComponentDimensions};
